import { render, staticRenderFns } from "./recentclr.vue?vue&type=template&id=70baa314&scoped=true&"
import script from "./recentclr.vue?vue&type=script&lang=js&"
export * from "./recentclr.vue?vue&type=script&lang=js&"
import style0 from "./recentclr.vue?vue&type=style&index=0&id=70baa314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70baa314",
  null
  
)

export default component.exports